import React from 'react'
import './blog.css';
import { Article } from '../../comp';
import {blog001, blog002, blog003, blog004, blog005} from './imports';
import { Link } from 'react-router-dom';
const Blog = () => {
  return (
    <div className='gpt3__blog section_padding' id='servicos'>
      <div className='gpt3__blog-heading'>
        <h1>
        Nossos Produtos e Soluções
        </h1>
        <Link to="/project">
          <div className='gpt3__cta-btn'>
          <button>Ver todos produtos</button>
          </div>
        </Link>
      </div>
      <div className='gpt3__blog-container'>
        <div className='gpt3__blog-container_groupA'>
        <Link to="/inogest"><Article imageUrl={blog001}  date="Sistema de Gestão" title="InoGest - Sistema completo de gestão empresarial desenvolvido para impulsionar pequenas e médias empresas, focado na simplicidade e eficiência."/></Link>
        </div>

        <div className='gpt3__blog-container_groupB'>
          <Link to="/edcmz"> <Article imageUrl={blog002} date="Educação" title="EDC MZ - Plataforma de exames da escola de condução que impulsiona o aprendizado teórico para obtenção da carta de condução."/></Link>
          <Link to="/clickclick"><Article imageUrl={blog003} date="Mobilidade Urbana" title="ClickClick - Plataforma mobile focada em soluções de mobilidade urbana, incluindo ClickTuk para motociclos e ClickTáxi para táxis."/></Link>
          <Link to="/baraquita"><Article imageUrl={blog004} date="Comércio" title="BaraQuita - Sistema criado para simplificar e inovar a gestão de pequenos comerciantes, barracas, takeaways e restaurantes."/></Link>
          <Link to="/simplify"><Article imageUrl={blog005} date="Gestão Corporativa" title="Simplify - Plataforma para simplificar a gestão de contratos e acordos a nível de serviços em ambientes corporativos."/></Link>
        </div>
      </div>
    </div>
  )
}

export default Blog
